var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"basicData layerWarp"},[(_vm.rendertpl)?_c(_vm.rendertpl,{tag:"component",staticClass:"component",attrs:{"params":_vm.params},on:{"fun_Details":_vm.fun_Details,"fun_Back":_vm.fun_Back}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }